import LogService from "../../CommonSdk/LogService";

import * as SearchService from "../../CommonSdk/SearchService";
import * as SearchActionTypes from "./SearchActionTypes";
import * as SearchConstant from "../../../components/Constants/SearchConstant";
import * as SearchUtils from "../../Utils/SearchUtils";

const LOG_TAG = "ACTIONS:SEARCH";

export const searchText = (value, filter = []) => (dispatch, getState) => {
    LogService.trace(LOG_TAG, "searchText", "search value", value);

    const promiseArray = [];

    const filterStsDocumentation = getState().documentation.filter === SearchUtils.DocumentationType.Sts;

    Object.values(SearchConstant.Sdk).forEach(sdk => {
        if (filter.some(filter => filter === SearchConstant.SearchFilterSdkPrefix + sdk)) {
            const indexes = SearchUtils.getSearchIndex(sdk, filterStsDocumentation);
            if (indexes) {
                indexes.forEach(indexKey => {
                    const index = getState().search.indexFiles[indexKey];
                    if (!index)
                        return;
                    const result = SearchService.searchTextInLunrIndex(index, value);
                    const path = SearchConstant.SearchIndexPaths[indexKey].replace(SearchConstant.SearchIndexFilename, "");
                    const searchResult = {
                        filter: SearchConstant.SearchFilterSdkPrefix + sdk,
                        resultPath: path,
                        result: result
                    }
                    promiseArray.push(Promise.resolve(searchResult));
                });
            }
        }
    });

    Object.values(SearchConstant.Api).forEach(api => {
        if (filter.some(filter => filter === SearchConstant.SearchFilterApiPrefix + api)) {
            const indexes = SearchUtils.getSearchIndex(api);
            if (indexes) {
                indexes.forEach(indexKey => {
                    const index = getState().search.indexFiles[indexKey];
                    if (!index)
                        return;
                    const result = SearchService.searchTextInLunrIndex(index, value);
                    const path = SearchConstant.SearchIndexPaths[indexKey].replace(SearchConstant.SearchIndexFilename, "");
                    const searchResult = {
                        filter: SearchConstant.SearchFilterApiPrefix + api,
                        resultPath: path,
                        result: result
                    }
                    promiseArray.push(Promise.resolve(searchResult));
                });
            }
        }
    });

    Object.values(SearchConstant.Other).forEach(other => {
        if (filter.some(filter => filter === SearchConstant.SearchFilterOtherPrefix + other)) {
            const indexes = SearchUtils.getSearchIndex(other);
            if (indexes) {
                indexes.forEach(indexKey => {
                    const index = getState().search.indexFiles[indexKey];
                    if (!index)
                        return;
                    const result = SearchService.searchTextInLunrIndex(index, value);
                    const path = SearchConstant.SearchIndexPaths[indexKey].replace(SearchConstant.SearchIndexFilename, "");
                    const searchResult = {
                        filter: SearchConstant.SearchFilterOtherPrefix + other,
                        resultPath: path,
                        result: result
                    }
                    promiseArray.push(Promise.resolve(searchResult));
                });
            }
        }
    });

    return Promise.allSettled(promiseArray)
        .then(results => {
            const searchResults = [];
            results.forEach((result, i) => {
                if (result.status === "fulfilled") {
                    searchResults.push(result.value);
                }
            });
            return Promise.resolve(searchResults);
        });

};

export const loadSearchIndexFiles = () => (dispatch) => {
    LogService.trace(LOG_TAG, "loadSearchIndexFiles");

    SearchService.loadSearchIndexFiles()
        .then(indexFileListObject => {
            if (indexFileListObject && Object.keys(indexFileListObject).length > 0) {
                dispatch({
                    type: SearchActionTypes.SEARCH_SET_INDEX_FILES,
                    payload: {
                        indexFiles: indexFileListObject
                    }
                });
            }
        });
};
